import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { container, infoColor } from '../../../assets/material-kit-react'
import GridContainer from '../../../components/grid/GridContainer'
import GridItem from '../../../components/grid/GridItem'
import Card from "../../../components/Card/Card";
import * as Sentry from '@sentry/browser'
import { withLocalize, Translate } from 'react-localize-redux';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet'
import {
    BrowserView,
    MobileView
} from "react-device-detect"

Sentry.init({
    dsn: "https://a2a837fdcc7047ee8369a55e2f144948@sentry.io/1337446"
   });

// mapboxgl.accessToken='pk.eyJ1IjoidGhpdG9vIiwiYSI6ImNqcDNramZ6YzBoZGIzdnA4emp2cGp0aHoifQ.847GwcOAVLvQkmb3TyZVsA'
// const Map = ReactMapboxGl(
//     {  
//         accessToken: 'pk.eyJ1IjoidGhpdG9vIiwiYSI6ImNqcDNramZ6YzBoZGIzdnA4emp2cGp0aHoifQ.847GwcOAVLvQkmb3TyZVsA',
//         scrollZoom: false
//     });




class Location extends Component {

    componentDidMount(){

    }

    componentDidCatch(error, errorInfo) {

        // Sentry.withScope(scope => {
        //     Object.keys(errorInfo).forEach(key => {
        //       scope.setExtra(key, errorInfo[key]);
        //     });
        //     Sentry.captureException(error);
        //   });
          
    }


    render(){
        const { classes }  = this.props
        return (
            <div className={classes.sections}>

                <div className={classes.container}>

                    <GridContainer >
                        <GridItem xs={12} sm={12} md={12}>
                            
                                <BrowserView>
                                    <div className={classes.gridContainer}>
                                        <Map className={classes.mapContainer} center={[16.7773699, 96.2275674]} 
                                                zoom={13} 
                                                zoomControl={false} 
                                                boxZoom={false} 
                                                scrollWheelZoom={false}
                                                closePopupOnClick={true}
                                                dragging={false}
                                            >
                                            <TileLayer
                                                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                url='http://{s}.tile.osm.org/{z}/{x}/{y}.png'
                                            />
                                            <Marker position={[16.7773699, 96.2275674]} ref={this.openPopup}>
                                                <Popup 
                                                    keepInView={true}
                                                    autoClose={true} 
                                                    closeButton={false} 
                                                    openPopup={true}
                                                    > 
                                                        <h4 className={classes.popupText}>

                                                            <Translate id="location"/>
                                                                
                                                        </h4>
                                                    </Popup>

                                            </Marker>
                                        </Map> 
                                    </div>
                                </BrowserView>

                                <MobileView className={classes.mobileView}>
                                    {/* <div className={classes.mapLinkContainer}> */}
                                        {/* <iframe 
                                            title="CityLoft"
                                            width="425" 
                                            height="350" 
                                            frameborder="0" 
                                            scrolling="no" 
                                            marginheight="0" 
                                            marginwidth="0" 
                                            src="https://www.openstreetmap.org/export/embed.html?bbox=96.19036674499512%2C16.746769998170002%2C96.26246452331544%2C16.80700602312312&amp;layer=mapnik&amp;marker=16.77687595186747%2C96.2264297157526">
                                        </iframe> */}
                                        {/* <br/> */}
                                        <Card className={classes.card}>
                                            <h4 className={classes.popupText}>
                                                <Translate id="location"/>
                                            </h4>
                                        </Card>
                                        
                                        <h5 className={classes.locationOnMap}>
                                            <img className={classes.icon} src={require('../../../images/mark.svg')} alt='icon'/>
                                            <a className={classes.mapLink} href="https://www.openstreetmap.org/?mlat=16.7769&amp;mlon=96.2264#map=14/16.7769/96.2264">
                                                See CityLoft Location on map
                                            </a>
                                        </h5>
                                    {/* </div> */}
                                </MobileView>

                        </GridItem>

                    </GridContainer>

                </div>

                
                  
                <footer>
                    <img src={require('../../../images/CityLoftFrame.svg')} alt="Frame"/>
                </footer>
            </div>
        )
    }

    openPopup (marker) {
        if (marker && marker.leafletElement) {
          window.setTimeout(() => {
            marker.leafletElement.openPopup()
          })
        }
    }
}


const styles = theme => ({
    sections: {
        flex: 1,
        minHeight: '100vh',
    },
    container: {
        ...container,
        background: "#FFFFFF",
        paddingLeft: '20px',
        paddingRight: '20px',
    },
    popupText: {
        maxWidth: '450px',
        fontFamily: '"Poppins"',
        fontSize: "14px",
        lineHeight: "1.5em",
        fontWeight: "300",
        paddingLeft: "20px",
        paddingRight: "20px",
        textAlign: "justify"
    },
    marker: {
        width: '40px',
        height: '40px'
    },
    gridContainer: {
        display: 'flex',
        minWidth: "80%",
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    mapContainer: {
        marginTop: "20px",
        width: "80vw",
        height: "80vh"
    },
    icon: {
        width: '20px',
        height: '20px',
    },
    card: {
        marginTop: "80px",
        marginBottom: "20px",
        paddingTop: "50px",
        paddingBottom: "50px"
    },
    mobileView: {
        padding: "10px"
    },
    locationOnMap: {
        textAlign: "center",
        marginTop: "60px",
        marginBottom: "60px"
    },
    mapLink: {
        fontSize: "1rem",
        fontWeight: "600",
        position: "relative",
        display: "inline",
        height: 0.5,
        fontFamily: '"Poppins"',
        color: infoColor
    },

    
})


Location.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withLocalize(withStyles(styles)(Location))
